import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
//import { OktaAuthService } from '@okta/okta-angular';
import { environment } from "../environments/environment";
import { Observable, of } from "rxjs";
import { catchError } from "rxjs/operators";
import { usuario } from './models/user';
import * as CryptoJS from 'crypto-js';
export interface AccessResponse {
  allowed: boolean;
}
@Injectable({
  providedIn: "root",
})
export class ServerService {
  constructor(private http: HttpClient) {}
  tokenFromUI: string = "UMMI1234";

  private async request(method: string, url: string, data?: any, params?: any) {
    //const token = await this.oktaAuth.getAccessToken();

    const result = this.http.request(method, url, {
      body: data,
      params: params,
      responseType: "json",
      observe: "body",
      headers: {
        //  Authorization: `Bearer ${token}`
      },
    });
    return new Promise((resolve, reject) => {
      result.subscribe(resolve, reject);
    });
  }
//documentado
  getUnidadesAcademicas() {
    return this.request("GET", `${environment.serverUrl}/unidadesAcademicas`);
  }

  createUnidadAcademica(unidadAcademica) {
    return this.request(
      "POST",
      `${environment.serverUrl}/unidadAcademica`,
      unidadAcademica
    );
  }
//documentado
  getPreguntas(idEncuesta) {
    return this.request(
      "GET",
      `${environment.serverUrl}/preguntas`,
      {},
      { id: idEncuesta }
    );
  }
//documentado
  getUbicaciones(){
    return this.request("GET", `${environment.serverUrl}/ubicaciones`);
  }
//documentado
  createInstance(preguntas,perfil) {
    let objetoFinal={
      'preguntas':preguntas,
      'perfil':perfil
    }

    return this.request("POST", `${environment.serverUrl}/preguntas`, objetoFinal);
  }
//no se usa
  updateEvent(event) {
    return this.request(
      "PUT",
      `${environment.serverUrl}/event/${event.id}`,
      event
    );
  }
//no se usa
  deleteEvent(event) {
    return this.request("DELETE", `${environment.serverUrl}/event/${event.id}`);
  }


//documentado
  insertAnswer(datos, encuesta){
    return this.request("POST", `${environment.serverUrl}/encuestados?encuesta=`+encuesta, datos);
  }
//documentado
  getEncuestado(carnetEncuestado, encuestaId){
    const url =`${environment.serverUrl}/getEncuestado?carnet=${carnetEncuestado}&encuesta_id=${encuestaId}`;
    return this.http.get<any>(url);
  }

//documentado
  getCamposReporte(idEncuesta): Observable<any[]>{
    const url=`${environment.serverUrl}/camposReporte?id=${idEncuesta}`;
    return this.http
      .get<any[]>(url);
  }
//documentado
  getEncuestas(idRol): Observable<any[]>{
    const url =`${environment.serverUrl}/getEncuestas?rol=${idRol}`;
    return this.http.get<any[]>(url);
  }
//documentado
  getTipoReportes(idEncuesta, idRol): Observable<any[]>{
    const url=`${environment.serverUrl}/obtenerTipoReportes?encuesta=${idEncuesta}&rol=${idRol}`;
    return this.http
      .get<any[]>(url);
  }
//documentado
  getEncuestadosExcel(idEncuesta): Observable<any[]>{
    const url=`${environment.serverUrl}/getEncuestadosExcel?encuesta=${idEncuesta}`;
    return this.http
      .get<any[]>(url);
  }
//documentado
  getRespuestasExcel(idEncuesta): Observable<any[]>{
    const url=`${environment.serverUrl}/getRespuestasExcel?encuesta=${idEncuesta}`;
    return this.http
      .get<any[]>(url);
  }

  getRequiereDatos(idEncuesta): Observable<any[]>{
    const url=`${environment.serverUrl}/requiereDatos?encuesta=${idEncuesta}`;
    return this.http
      .get<any[]>(url);
  }

  getEncuestadosExcelFiltrado(idEncuesta, body){
  //  console.log("excel filtrado",JSON.stringify(body))
    const url=`${environment.serverUrl}/getEncuestadosExcelFiltrado`;
    //console.log(body.JSON.)
    return this.request(
      "POST",
      url,
      body,
      {
        encuesta: idEncuesta,
      }
    );

  }
//documentado
  getRespuestasExcelFiltrado(idEncuesta, body){
    const url=`${environment.serverUrl}/getRespuestasExcelFiltrado`;
    return this.request(
      "POST",
      url,
      body,
      {
        encuesta: idEncuesta,
      }
    );
  }
//documentado
  getTiposPregunta(){
    const url=`${environment.serverUrl}/getTipoPregunta`;
    return this.http
      .get<any[]>(url);
  }
//documentado
  getTiposRespuesta(){
    const url=`${environment.serverUrl}/getTipoRespuesta`;
    return this.http
      .get<any[]>(url);
  }

  getTiposBaremo(){
    const url=`${environment.serverUrl}/getTipoBaremo`;
    return this.http
      .get<any[]>(url);
  }

  crearEncuesta(body){
    const url=`${environment.serverUrl}/crearEncuesta`;
    return this.request(
      "POST",
      url,
      body
    );
  }

  getAccesosEncuestasLibres(idEncuesta: Number): Observable<AccessResponse>{
    const url=`${environment.serverUrl}/getAccesosEncuestasLibres?encuesta=${idEncuesta}`;
    return this.http.get<AccessResponse>(url);
}

  private handleError<T>(operation = "operation", result?: T) {
    return (error: any): Observable<T> => {
      console.error("handleError => ", error);
      return of(result as T);
    };
  }
  //metodos para registro documentado
  postRegistro(usuario: usuario){
    const encriptada = this.encryptUsingAES256(this.tokenFromUI, usuario.password.toString());
    usuario.password = encriptada;
    return this.http.post(`${environment.serverUrl}/registrarUsuario`, usuario);
  }
  //documentado
  //metodo para login
  postLogin(carnet:String, contrasena: string) {
    const encriptada = this.encryptUsingAES256(this.tokenFromUI, contrasena);
    return this.http.post(`${environment.serverUrl}/login`, {  "carnet": carnet, "contrasenia": encriptada});
  }
  //documentado
   //metodo para actualizar estado habilitado y deshabilitado
   putActualizarEstado(estado:Number,carnet:String) {
    return this.http.put(`${environment.serverUrl}/cambiarEstadoUsuario`, { "estado":estado, "carnet": carnet });
  }
  //obtener usaurios para crud
  //documentado
  getUsuarios(): Observable<any[]>{
    const url =`${environment.serverUrl}/getUsuarios`;
    return this.http.get<any[]>(url);
  }
  //documentado
  putReseteoPass(carnet:String, bandera:Number,contrasena: string) {
    const encriptada = this.encryptUsingAES256(this.tokenFromUI, contrasena);
    return this.http.put(`${environment.serverUrl}/reseteoPass`, {  "carnet": carnet, "banderareseteo":bandera, "contrasenia": encriptada});
  }
  //documentado
  getEncuestaslibres(): Observable<any[]>{
    const url =`${environment.serverUrl}/getEncuestaslibres`;
    return this.http.get<any[]>(url);
  }
//documentado
  getEncuestasprofesores(): Observable<any[]>{
    const url =`${environment.serverUrl}/getEncuestasdocentes`;
    return this.http.get<any[]>(url);
  }
  //documentado
  getEncuestasestudiantes(): Observable<any[]>{
    const url =`${environment.serverUrl}/getEncuestasestudiantes`;
    return this.http.get<any[]>(url);
  }
  //documentado
  getCarnets(): Observable<any[]>{
    const url =`${environment.serverUrl}/getCarnets`;
    return this.http.get<any[]>(url);
  }

    //documentado
  getCarnetsPorEncuesta(encuestaId:Number, usuario :String, rol :String, coordinador :Number): Observable<any[]>{
    const url =`${environment.serverUrl}/getCarnetsPorEncuesta`;
    return this.http.post<any[]>(url, { "encuesta":encuestaId, "usuario":usuario, "rol":rol, "coordinador":coordinador   });
  }


  getInformacionJefeArea(usuario): Observable<any[]>{
    const url=`${environment.serverUrl}/obtenerInformacionJefeArea?usuario=${usuario}`;
    return this.http
      .get<any[]>(url);
  }

  getSeccionesUsuario(encuestaId :Number, usuario :String, rol :String, coordinador :Number): Observable<any[]>{
    const url =`${environment.serverUrl}/getSeccionesUsuario`;
    return this.http.post<any[]>(url, {"encuesta":encuestaId, "usuario":usuario , "rol":rol , "coordinador":coordinador});
  }

 encryptUsingAES256(tokenFromUI: string, request: string):string {
    let _key = CryptoJS.enc.Utf8.parse(tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(tokenFromUI);
    let encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(request), _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
    return encrypted.toString();
  }
  decryptUsingAES256(tokenFromUI: string, encrypted: string) {
    let _key = CryptoJS.enc.Utf8.parse(tokenFromUI);
    let _iv = CryptoJS.enc.Utf8.parse(tokenFromUI);

    return CryptoJS.AES.decrypt(
      encrypted, _key, {
        keySize: 16,
        iv: _iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      }).toString(CryptoJS.enc.Utf8);
  }
}
